import type { Messages } from "../catalogue.en";

export const financeSettlement: Partial<Messages> = {
  "finance.settlement.responsibilitiesTitle": "אחריות תשלום",
  "finance.settlement.responsibilitiesTableLabel": "עמדות אחריות תשלום",
  "finance.settlement.responsibilitiesLoading": "טוען עמדות אחריות",
  "finance.settlement.responsibilitiesFailed": "לא ניתן לטעון את עמדות האחריות.",
  "finance.settlement.responsibilitiesEmpty": "אין עמדות אחריות",
  "finance.settlement.responsibilitiesEmptyDetail":
    "התחייבויות מאושרות שניתן להקצות להן כסף יעמדו כאן.",
  "finance.settlement.columnServiceDate": "תאריך שירות",
  "finance.settlement.columnBeneficiary": "מוטב",
  "finance.settlement.columnDueDate": "לתשלום עד",
  "finance.settlement.columnOutstanding": "יתרה לתשלום",
  "finance.settlement.columnAllocatable": "ניתן להקצאה",
  "finance.settlement.columnSettled": "סולק",
  "finance.settlement.dueStatus.unresolved": "ללא מועד",
  "finance.settlement.dueStatus.not_due": "טרם הגיע",
  "finance.settlement.dueStatus.due": "לתשלום היום",
  "finance.settlement.dueStatus.overdue": "באיחור",
  "finance.settlement.dueStatus.settled": "סולק",
  "finance.settlement.allocationsTitle": "הקצאות",
  "finance.settlement.allocationsTableLabel": "הקצאות",
  "finance.settlement.allocationsLoading": "טוען הקצאות",
  "finance.settlement.allocationsFailed": "לא ניתן לטעון את ההקצאות.",
  "finance.settlement.allocationsEmpty": "אין הקצאות עדיין",
  "finance.settlement.allocationsEmptyDetail":
    "כסף שנקשר לעמדות אחריות יעמוד כאן.",
  "finance.settlement.columnPostingDate": "תאריך רישום",
  "finance.settlement.columnKind": "סוג",
  "finance.settlement.columnAmount": "סכום",
  "finance.settlement.columnReversible": "ניתן לשחרור",
  "finance.settlement.columnRecorded": "נרשם",
  "finance.settlement.kindAllocation": "הקצאה",
  "finance.settlement.kindReversal": "שחרור",
  "finance.settlement.digestTitle": "הקצאה",
  "finance.settlement.allocate": "הקצאת כספים",
  "finance.settlement.reverse": "שחרור",
  "finance.settlement.reallocate": "הקצאה מחדש",
  "finance.settlement.allocateTitle": "הקצאת כספים",
  "finance.settlement.allocateDetail":
    "קשירת כסף זמין מתקבול לעמדת אחריות מאושרת אחת.",
  "finance.settlement.allocateSubmit": "להקצות",
  "finance.settlement.allocateSubmitting": "מקצה",
  "finance.settlement.allocateUnsaved": "הקצאה שטרם נשלחה",
  "finance.settlement.reverseTitle": "שחרור כספים",
  "finance.settlement.reverseDetail": "החזרת חלק מההקצאה הזו לתקבול המקורי שלה.",
  "finance.settlement.reverseSubmit": "לשחרר",
  "finance.settlement.reverseSubmitting": "משחרר",
  "finance.settlement.reverseUnsaved": "שחרור שטרם נשלח",
  "finance.settlement.reallocateTitle": "הקצאת כספים מחדש",
  "finance.settlement.reallocateDetail":
    "שחרור חלק מההקצאה הזו וקשירתו לעמדה אחרת, בפקודה אחת.",
  "finance.settlement.reallocateSubmit": "להקצות מחדש",
  "finance.settlement.reallocateSubmitting": "מקצה מחדש",
  "finance.settlement.reallocateUnsaved": "הקצאה מחדש שטרם נשלחה",
  "finance.settlement.unsavedDetail": "הפרטים שהוקלדו יימחקו.",
  "finance.settlement.receiptField": "תקבול מקור",
  "finance.settlement.receiptRequired": "יש לבחור את התקבול שממנו מגיע הכסף.",
  "finance.settlement.receiptOption": "{date} — זמין {amount}",
  "finance.settlement.targetOwnerField": "בעלים של היעד",
  "finance.settlement.targetOwnerPlaceholder": "חיפוש אנשים וישויות משפטיות",
  "finance.settlement.targetAccountNone": "לבעלים האלה אין חשבון חיוב פעיל.",
  "finance.settlement.targetFailed": "לא ניתן לקרוא את חשבון היעד.",
  "finance.settlement.portionField": "עמדת אחריות",
  "finance.settlement.portionRequired": "יש לבחור את העמדה שאליה נקשר הכסף.",
  "finance.settlement.portionOption": "{date} — ניתן להקצאה {amount}",
  "finance.settlement.amountField": "סכום",
  "finance.settlement.amountRequired": "יש להקליד את הסכום להעברה.",
  "finance.settlement.amountExceeds":
    "הסכום גדול ממה שהמקור או העמדה מאפשרים.",
  "finance.settlement.instructionField": "אסמכתת הוראה",
  "finance.settlement.instructionRequired":
    "יש לציין את ההוראה שהמהלך פועל לפיה — מסמך, הודעה או ספח.",
  "finance.settlement.crossOwnerConfirm":
    "בעלי החשבון הורו על המהלך הזה לחשבון של צד אחר.",
  "finance.settlement.crossOwnerRequired": "יש לאשר את הוראת הבעלים.",
  "finance.settlement.reasonField": "סיבה",
  "finance.settlement.reasonRequired": "יש לציין את הסיבה.",
  "finance.settlement.accountsLoading": "קורא את החשבונות",
  "finance.settlement.accountsFailed": "לא ניתן לקרוא את החשבונות.",
  "finance.settlement.reload": "לקרוא את החשבונות מחדש",
  "finance.settlement.reloadFailed": "לא ניתן לקרוא את החשבונות מחדש.",
  "finance.settlement.reloaded":
    "החשבונות נקראו מחדש. יש לבדוק את הטיוטה ולשלוח.",
  "finance.settlement.failed": "לא ניתן להשלים את פקודת הסילוק.",
  "finance.settlement.conflict":
    "חשבון השתנה בזמן העבודה. יש לקרוא את החשבונות מחדש ולשלוח.",
  "finance.settlement.accountStateConflict":
    "מצב מחזור החיים של החשבון אינו מאפשר את המהלך הזה.",
  "finance.settlement.eligibilityConflict":
    "זכאות העמדה השתנתה. יש לקרוא את החשבונות מחדש ולבדוק את העמדה.",
  "finance.settlement.responsibilityExceeded":
    "הסכום חורג ממה שהעמדה הזו עוד מאפשרת.",
  "finance.settlement.fundsInsufficient":
    "בתקבול כבר אין סכום זמין כזה.",
  "finance.settlement.fundsRestricted":
    "כספי התקבול הזה מוגבלים לטובת מטופל אחד ואינם יכולים לממן את העמדה הזו.",
  "finance.settlement.reversalExceeded":
    "הסכום חורג ממה שההקצאה הזו עוד יכולה לשחרר.",
  "finance.settlement.delegationUnavailable":
    "ההרשאה שהמהלך הזה נשען עליה אינה זמינה.",
  "finance.settlement.periodClosed":
    "התקופה הכספית של התאריך הזה סגורה. יש לפתוח אותה תחילה בניהול הכספים.",
  "finance.settlement.amountInvalid":
    "לא ניתן לקרוא את הסכום. יש להקליד אותו בתבנית המספרים של המרפאה.",
  "finance.settlement.amountOverflow": "הסכום גדול מדי.",
  "finance.settlement.currencyMismatch": "מטבע הסכום אינו תואם את מטבע החשבון.",
  "finance.settlement.attemptConflict":
    "הניסיון הזה כבר נשלח עם פרטים אחרים. יש לסגור את הטופס ולהתחיל מחדש.",
  "finance.settlement.forbidden": "אין לך הרשאה להעביר כספים מוחזקים.",
  "finance.settlement.invalid": "יש לבדוק את הפרטים שהוזנו.",

  "finance.refunds.title": "החזרים",
  "finance.refunds.tableLabel": "החזרים",
  "finance.refunds.loading": "טוען החזרים",
  "finance.refunds.loadFailed": "לא ניתן לטעון את ההחזרים.",
  "finance.refunds.empty": "לא נרשמו החזרים",
  "finance.refunds.emptyDetail": "תשלומים שיצאו בפועל מהחשבון הזה יעמדו כאן.",
  "finance.refunds.columnCashDate": "תאריך קופה",
  "finance.refunds.columnRecipient": "מקבל",
  "finance.refunds.columnMethod": "אמצעי",
  "finance.refunds.columnAmount": "סכום",
  "finance.refunds.columnRecorded": "נרשם",
  "finance.refunds.recordAction": "רישום החזר",
  "finance.refunds.recordTitle": "רישום החזר",
  "finance.refunds.recordDetail":
    "עדות לתשלום שיצא בפועל חזרה למשלם המקורי של התקבול.",
  "finance.refunds.recordSubmit": "לרשום החזר",
  "finance.refunds.recordSubmitting": "רושם",
  "finance.refunds.previewLoading": "קורא את תקרת ההחזר",
  "finance.refunds.previewFailed": "לא ניתן לקרוא את תקרת ההחזר.",
  "finance.refunds.originalPayer": "משלם מקורי",
  "finance.refunds.originalMethod": "אמצעי מקורי",
  "finance.refunds.originalCashDate": "תאריך קופה מקורי",
  "finance.refunds.maximum": "זמין להחזר",
  "finance.refunds.amountField": "סכום",
  "finance.refunds.amountRequired": "יש להקליד את הסכום ששולם.",
  "finance.refunds.amountExceedsMax": "הסכום גדול ממה שהתקבול הזה יכול להחזיר.",
  "finance.refunds.methodField": "אמצעי",
  "finance.refunds.methodChangeReasonField": "סיבת שינוי האמצעי",
  "finance.refunds.methodChangeReasonRequired":
    "יש לציין מדוע אמצעי התשלום שונה מהמקורי.",
  "finance.refunds.cashDateField": "תאריך קופה",
  "finance.refunds.evidenceField": "אסמכתת עדות",
  "finance.refunds.evidenceRequired":
    "יש לציין את עדות התשלום — ספח, העברה או אסמכתת קופה.",
  "finance.refunds.reasonField": "סיבה",
  "finance.refunds.reasonRequired": "יש לציין את הסיבה.",
  "finance.refunds.unsavedIntent": "החזר שטרם נרשם",
  "finance.refunds.unsavedDetail": "ההחזר שהוקלד יימחק.",
  "finance.refunds.reload": "לקרוא את התקבול מחדש",
  "finance.refunds.reloadFailed": "לא ניתן לקרוא את התקבול מחדש.",
  "finance.refunds.reloaded": "התקבול נקרא מחדש. יש לבדוק את הטיוטה ולשלוח.",
  "finance.refunds.failed": "לא ניתן לרשום את ההחזר.",
  "finance.refunds.conflict":
    "החשבון השתנה בזמן העבודה. יש לקרוא את התקבול מחדש ולשלוח.",
  "finance.refunds.exceedsAvailable":
    "בתקבול כבר אין סכום כזה להחזר. יש לקרוא את התקבול מחדש.",
  "finance.refunds.evidenceAlreadyRecorded":
    "החזר עם העדות הזו כבר נרשם על התקבול הזה.",
  "finance.refunds.periodClosed":
    "התקופה הכספית של תאריך הקופה הזה סגורה. יש לפתוח אותה בניהול הכספים או לבחור תאריך אחר.",
  "finance.refunds.amountInvalid":
    "לא ניתן לקרוא את הסכום. יש להקליד אותו בתבנית המספרים של המרפאה.",
  "finance.refunds.amountOverflow": "הסכום גדול מדי.",
  "finance.refunds.currencyMismatch": "מטבע הסכום אינו תואם את מטבע החשבון.",
  "finance.refunds.attemptConflict":
    "הניסיון הזה כבר נשלח עם פרטים אחרים. יש לסגור את הטופס ולהתחיל מחדש.",
  "finance.refunds.forbidden": "אין לך הרשאה לרשום החזרים.",
  "finance.refunds.invalid": "יש לבדוק את פרטי ההחזר שהוזנו.",
};
